import { render, staticRenderFns } from "./CreateCheckpointAddressFormB2b.vue?vue&type=template&id=f427cfd6"
import script from "./CreateCheckpointAddressFormB2b.vue?vue&type=script&lang=js"
export * from "./CreateCheckpointAddressFormB2b.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports